var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MessageCard',{attrs:{"type":"error","message":_vm.$t('errors.unsupported_provider')}})
}
var staticRenderFns = []

export { render, staticRenderFns }